import { StatusIndicator, StatusIndicatorProps } from '@cloudscape-design/components';

const STATUS_TYPE: Record<string, StatusIndicatorProps.Type> = {
  pending: 'pending',
  discovering: 'in-progress',
  building: 'in-progress',
  pushing_leads: 'in-progress',
  scheduling: 'in-progress',
  complete: 'success',
  failed: 'error',
  cancelled: 'stopped',
};

const STATUS_LABEL: Record<string, string> = {
  pending: 'Pending',
  discovering: 'Discovering',
  building: 'Building scorecards',
  pushing_leads: 'Pushing leads',
  scheduling: 'Scheduling',
  complete: 'Complete',
  failed: 'Failed',
  cancelled: 'Cancelled',
};

export function ZipBlastStatusBadge({ status }: { status: string }) {
  const type = STATUS_TYPE[status] ?? 'in-progress';
  const label = STATUS_LABEL[status] ?? status;
  return <StatusIndicator type={type}>{label}</StatusIndicator>;
}
